import React from "react";
import HomeRoundedIcon from "@mui/icons-material/HomeRounded";
import AddShoppingCartIcon from "@mui/icons-material/AddShoppingCart";
import RemoveShoppingCartIcon from "@mui/icons-material/RemoveShoppingCart";
import RestaurantMenuIcon from "@mui/icons-material/RestaurantMenu";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import BusinessIcon from "@mui/icons-material/Business";
import EventIcon from "@mui/icons-material/Event";
import MenuBase from "./MenuBase";
import { useUser } from "../../contexts/UserContext";
import { canShowNiyazCalendarRegardlessOfAccess } from "../../util";

const MenuContentStore = ({ open }) => {
    const { user } = useUser();
    const menuItems = [
        { label: "Dashboard", icon: <HomeRoundedIcon />, path: "/dashboard" },
        { label: "Store In", icon: <AddShoppingCartIcon />, path: "/store-in-items" },
        { label: "Store Out", icon: <RemoveShoppingCartIcon />, path: "/store-out-items" },
        { label: "Menu Dish", icon: <RestaurantMenuIcon />, path: "/store-menu-dish" },
        { label: "Items", icon: <ShoppingCartIcon />, path: "/store-items" },
        { label: "Vendors", icon: <BusinessIcon />, path: "/store-vendors" },
        ...(canShowNiyazCalendarRegardlessOfAccess(user)
            ? [{ label: "Niyaz Calendar", icon: <EventIcon />, path: "/niyaz-calendar" }]
            : []),
    ];

    return <MenuBase open={open} menuItems={menuItems} />;
};

export default MenuContentStore;